import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';

const DropBox = styled.div``;

const ScreenRecordMain = styled.div<{ isStartFromVideo?: boolean }>`
  margin-top: var(--space-12);
  ${mobile_xl(css`
    width: 100%;
    margin-top: var(--space-8);
  `)}
  .e-rte-video .e-video-inline {
    width: 355px;
  }

  .react-player__play-icon {
    display: none;
  }
  .active {
    border-radius: var(--border-radius-4);
    background-color: var(--neutral-secondary);
  }
`;

const YoutubePlayer = styled.div`
  height: 200px;
  width: 353px;
  .img-thumbnail {
    border: 0.5px solid var(--border-primary);
    max-width: unset;
  }
  ${mobile_xl(css`
    width: 100%;
    height: auto;
    .img-thumbnail {
      width: 100% !important;
      height: auto !important;
      border: unset;
      border-radius: var(--border-radius-0);
    }
  `)}
`;

export { DropBox, ScreenRecordMain, YoutubePlayer };
